import React from "react";
import logo from "../../assets/images/acumenVelocityLogo.svg";
import { Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { TiTick } from "react-icons/ti";
import { FaInfoCircle } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import GoogleLoginButton from "../../components/button/googleLogin";

export const Login = () => {
  const navigate = useNavigate();

  const renderTooltip = (props) => (
    <Tooltip id="info-tooltip" {...props}>
      Gmail users Signup and Login using Google.
      <br />
      Other users, Signup and Login using email and password.
      <br />
      Note: Signup is enabled only for invited users.
    </Tooltip>
  );

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{ backgroundColor: "#E9EEF7" }}
    >
      <div
        className="d-flex align-items-center cursor_pointer p-2"
        style={{ height: "8vh" }}
        onClick={() => navigate("/")}
      >
        <Image alt="logo" src={logo} height={40} className="mx-2" />
        <p className="name fs_18 fw_600 m-0 ">Acumen Translation Hub</p>
      </div>
      <div className="flex-grow-1 d-flex justify-content-center align-items-center fn_Roboto">
        <div className="bg-light d-flex flex-column flex-md-row justify-content-center align-items-center p-4 rounded-3 mx-2 mx-md-5 gap-2 col-12 col-md-8 col-lg-6">
          <div className="w-100 w-md-50 p-3">
            <p className='fn_Roboto text_title fs_28 fs_sm_18'>Acumen Translation Hub</p>
            <p className="fs_14 sub_title">
              Make your documents multilingual with a single click. Translate
              from 1 to many languages in a single step!
            </p>
            <ul className="list-unstyled fs_14 fn_google_sans">
              <li className="d-flex align-items-center">
                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                <span>Fast translation for PDF’s, Word and Powerpoints</span>
              </li>
              <li className="d-flex align-items-center">
                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                <span>Full format retention</span>
              </li>
              <li className="d-flex align-items-center">
                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                <span>Customize translations with your own models or</span>
              </li>
              <li className="d-flex align-items-center">
                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                <span>Use Google's Neural Machine Translation model</span>
              </li>
              <li className="d-flex align-items-center">
                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                <span>Single, transparent pricing</span>
              </li>
            </ul>
            {/* <div className='mt-2 text-start mx-4 fn_google_sans'>
              <h5 className='fs_18 fw_400'>Are you a new company?</h5>
              <span className='fs_14'>Create your company's account and join us today by </span>
              <span
                className='fs_14 text-primary cursor_pointer fs_14 fw_700'
                style={{ textDecoration: 'underline' }}
                onClick={() => navigate('/company/register')}>
                Register here!
              </span>
            </div> */}
          </div>
          <div className="w-100 w-md-50 p-4 mt-4 mt-md-0 border rounded">
            <p className="fs_18 fw_400 text-black fn_google_sans">
              Sign in to Acumen Translation Hub
            </p>
            <GoogleLoginButton />
            <Button
              style={{ width: 300, borderRadius: '3px' }}
              className="mt-4 text-start"
              onClick={() => {
                navigate(`/email-login`);
              }}
            >
              <GrMail
                style={{
                  color: "#fff",
                  marginLeft: "20%",
                  marginRight: "30px",
                }}
              />
              Sign in with Email
            </Button>
            {/* <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <div
                className="text-center mt-3"
                style={{
                  cursor: "pointer",
                }}
              >
                <FaInfoCircle
                  style={{
                    cursor: "pointer",
                    color: "#3995E7",
                    fontSize: "1.5rem",
                  }}
                />
              </div>
            </OverlayTrigger> */}
          </div>
        </div>
      </div>
    </div>
  );
};
